module.exports = __webpack_public_path__ + "static/media/select-columns-icon.16c766e4.svg";